/**
 * External dependencies
 */
import { Component, Fragment } from '@wordpress/element';
import { Button, Popover } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import './style.scss';

class BookingDetails extends Component {
	render() {
		const { booking }     = this.props;
		const { orderMeta }   = booking;
		let parsedOrderMeta   = [];

		if ( orderMeta ) {
			parsedOrderMeta = JSON.parse( orderMeta );
		}

		return (
			<Fragment>
			<div>
				<div id="event_detail_header">
					<h3>{ booking.title }</h3>
				</div>
				<div id="event_detail_body">
					<div id="booking_status">
						{ booking.status && (<span>{ booking.status }</span>) }
					</div>

					<ul>
						{ (booking.date && booking.time) && (
							<li className="daily_popover_datetime_icon">
								<span><strong>{ booking.date }<br />{ booking.time }</strong></span>
							</li>
						) }

						{ booking.customer && (
							<li className="daily_popover_customer_icon">
								<span>
									<strong>{ wc_bookings_admin_js_params.i18n_customer }</strong>
									{ booking.customer }
								</span>
							</li>
						) }

						{ booking.resource && (
							<li className="daily_popover_resource_icon">
								<span>
									<strong>{ wc_bookings_admin_js_params.i18n_resource }</strong>
									{ booking.resource.split( ',' ).join( '<br />' ) }
								</span>
							</li>
						)}

						{ booking.persons && (
							<li className="daily_popover_persons_icon">
								<span>
									<strong>{ wc_bookings_admin_js_params.i18n_persons }</strong>
									{ booking.persons }
								</span>
							</li>
						) }

						{
							parsedOrderMeta.map( ( { attrs, title }, index ) => (
								<>
									<li class="daily_popover_group_title"><strong>{ title }</strong></li>
									{
										Object.keys( attrs ).map( ( metaKey ) => (
											<li className="daily_popover_order_meta_item" dangerouslySetInnerHTML={ { __html: `<strong>${ metaKey }</strong>${ attrs[ metaKey ] }` } } />
										) )
									}
								</>
							) )

						}
					</ul>
				</div>
				{ booking.url && (
				<div id="event_detail_footer">
					<a href={ booking.url }>{ wc_bookings_admin_js_params.i18n_view_details }</a> <span>&rarr;</span>
				</div>
				) }
			</div>
			</Fragment>
		);
	}
}

class CalendarPopover extends Component {
	constructor( props ) {
		super( props );

		this.state = {
			showPicker: false,
		};
	}

	getBookingData() {
		const attrs = this.props.element.attributes;
		const mapping = {
			'data-id': 'id',
			'data-status': 'status',
			'data-booking-title': 'title',
			'data-booking-url': 'url',
			'data-booking-date': 'date',
			'data-booking-time': 'time',
			'data-booking-customer': 'customer',
			'data-booking-resource': 'resource',
			'data-booking-persons': 'persons',
			'data-order-meta': 'orderMeta'
		};
		let booking = {};

		Object.entries( mapping ).forEach(
			([attrName, propName]) => {
				booking[ propName ] = attrs.getNamedItem( attrName ) ? attrs.getNamedItem( attrName ).value : '';
			}
		);

		// Sanitize URL.
		booking['url'] = booking['url'] ? booking['url'].trim() : '';
		if ( ! /^https?:\/\/[^\s'"<>]+$/gi.test( booking['url'] ) ) {
			booking['url'] = '';
		}

		return booking;
	}

	toggleVisibility = ( e ) => {
		e.preventDefault();

		const { showPicker } = this.state;
		this.setState( {
			showPicker: ! showPicker,
		} );
	}

	closePopover = () => {
		this.setState( {
			showPicker: false,
		} );
	}

	parseStyles = ( styles ) => styles
    	.split( ';' )
   		.filter( ( style ) => style.split( ':' )[ 0 ] && style.split( ':' )[ 1 ] )
    	.map( ( style ) => [
        	style.split( ':' )[ 0 ].trim().replace( /-./g, ( c ) => c.substr( 1 ).toUpperCase() ),
        	style.split( ':' )[ 1 ].trim(),
    	] )
    	.reduce( ( styleObj, style ) => ( {
        	...styleObj,
        	[ style[ 0 ] ]: style[ 1 ],
		} ), {} );

	render() {
		const { showPicker } = this.state;
		const { getAnchorRect, position } = this.props;

		const attr = this.props.element.attributes;
		const classes = attr.getNamedItem( 'data-classes' ) ? attr.getNamedItem( 'data-classes' ).value : '';
		const styles = attr.getNamedItem( 'data-style' ) ? this.parseStyles( attr.getNamedItem( 'data-style' ).value ) : {};

		const booking = this.getBookingData();

		return (
			<Fragment>
				<a href={ booking.url } className={ classes } style={ styles } onClick={ this.toggleVisibility }>
					<span className="booking-calendar-booking-title">{ booking.customer + ( booking.customer ? ', ' : '' ) + booking.title }</span>
					<span className="booking-calendar-time-range">{ booking.time }</span>
				</a>
				{ showPicker && (
					<Popover
						className="wc-bookings-calendar-popover"
						focusOnMount={ 'firstElement' }
						getAnchorRect={ getAnchorRect }
						position={ position }
						onFocusOutside={ this.closePopover }
					>
						<Button className="wc-bookings-calendar-popover-close" onClick={ this.closePopover } >
							{ __( 'Close', 'woocommerce-bookings' ) }
						</Button>

						<BookingDetails booking={ booking } />
					</Popover>
				) }
			</Fragment>
		);
	}
}

export default CalendarPopover;
